module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-mindfulness-skills@3x.86b2075a.png";